module.exports = __webpack_public_path__ + "static/YuanitaSafitriDiantiMD-7964048c8d8e15a16503c3180614426d.jpg";